import { TPermissions } from "@/data/types";
import { State } from "../state/state";

export const getOrganizationId = (state: State) => state.session.organizationId;

export const getCurrentSessionUser = (state: State) =>
  state.session.currentUser;
export const getCurrentSessionPermissions = (state: State): TPermissions[] =>
  state?.session?.currentUser?.profiles?.[0]?.permissions ?? [];
